import { axios } from "../../../lib/axios";

export const webRTC_info = (payload, orgId) => {
  return axios.post(`device/webrtc?orgId=${orgId}`, payload);
};